
export const CUSTOM_FIELD_TYPE = {
    TEXT     : "text",
    TEXT_AREA: "textarea",
    NUMBER   : "number",
    SELECT   : "select",
    CHECKBOX : "checkbox",
    EMAIL    : "email"
};

export const OPTIONS_FIELD_TYPE = [
    { label: "Text", value: CUSTOM_FIELD_TYPE.TEXT },
    { label: "Text Area", value: CUSTOM_FIELD_TYPE.TEXT_AREA },
    { label: "Number", value: CUSTOM_FIELD_TYPE.NUMBER },
    { label: "Select", value: CUSTOM_FIELD_TYPE.SELECT },
    { label: "Checkbox", value: CUSTOM_FIELD_TYPE.CHECKBOX },
    { label: "Email", value: CUSTOM_FIELD_TYPE.EMAIL }
];

export const OPTIONS_STATUS = [
    { label: "Active", value: "active" },
    { label: "Deleted", value: "deleted" }
];

export const FIELD_OPTIONS = [CUSTOM_FIELD_TYPE.TEXT, CUSTOM_FIELD_TYPE.TEXT_AREA, CUSTOM_FIELD_TYPE.NUMBER, CUSTOM_FIELD_TYPE.EMAIL];
